import { useCallback, useEffect, useState } from "react";

import { useQuery } from "hooks";

const useTablePagination = (query, options = {}, pageSize = 10) => {
  const [pageControl, setPageControl] = useState({
    page: 0,
    pageSize: pageSize,
  });

  const updatePageControl = useCallback((newCondition) => {
    setPageControl((prevCondition) => {
      return { ...prevCondition, ...newCondition };
    });
  }, []);

  const queryFactory = useCallback(() => {
    return query({ ...pageControl });
  }, [pageControl, query]);

  const { reloadData, ...queryResult } = useQuery(queryFactory, options);

  useEffect(() => {
    reloadData();
  }, [pageControl, reloadData]);

  return {
    pageControl: pageControl,
    updatePageControl: updatePageControl,
    reloadData: reloadData,
    ...queryResult,
  };
};

export default useTablePagination;
